// ================== Service file ==================
// ProjectBoardServices/BoardModalAPI/LeftModalAPI/DeliverablesTabAPI.js

import { axiosInstance } from "../../../../Services";

export const fetchCardDeliverables = async (cardId) => {
  try {
    const res = await axiosInstance.get(`/mmhboard/cards/deliverable/${cardId}`);
    return res;
  } catch (error) {
    throw error;
  }
};

// ✅ Approve API
export const approveDesign = async (cardId, deliverableId) => {
  try {
    const res = await axiosInstance.post(
      `/mmhboard/cards/update_design_status/${cardId}/approved/${deliverableId}`,
      {},
    );
    return res;
  } catch (error) {
    throw error;
  }
};

// ✅ Decline API
export const declineDesign = async (cardId, deliverableId) => {
  try {
    const res = await axiosInstance.post(
      `/mmhboard/cards/update_design_status/${cardId}/declined/${deliverableId}`,
      {},
    );
    return res;
  } catch (error) {
    throw error;
  }
};
